import { H4, Muted } from '@/components/sv/typographies'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Separator } from '@/components/ui/separator'
import { Skeleton } from '@/components/ui/skeleton'

export const EventDetailsFallback = () => {
  return (
    <div className="space-y-0">
      <Card className="p-4 border-0 shadow-none gap-2">
        <CardHeader className="p-0">
          <CardTitle>
            <H4>Details</H4>
          </CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          <div className="grid grid-cols-[auto_1fr] gap-y-2 gap-x-6 items-center">
            <Muted>Type</Muted>
            <Skeleton className="h-4 w-24 my-0.5" />
            <Muted>Status</Muted>
            <Skeleton className="h-4 w-21  my-0.5" />
            <Muted>Attempt date</Muted>
            <Skeleton className="h-4 w-50 my-1" />
            <Muted>Endpoint</Muted>
            <Skeleton className="h-6 w-55 rounded-md" />
            <Muted>Event ID</Muted>
            <Skeleton className="h-6 w-80 rounded-md" />
          </div>
        </CardContent>
      </Card>
      <Separator />
      <Card className="p-4 border-0 shadow-none gap-2">
        <CardHeader className="p-0">
          <CardTitle>
            <H4>Request</H4>
          </CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          <Skeleton className="h-50 w-full" />
        </CardContent>
      </Card>
      <Separator />
      <Card className="p-4 border-0 shadow-none gap-2">
        <CardHeader className="p-0">
          <CardTitle>
            <H4>Response</H4>
          </CardTitle>
          <CardDescription>
            <Skeleton className="h-5 w-60" />
          </CardDescription>
        </CardHeader>
        <CardContent className="p-0">
          <Skeleton className="h-50 w-full" />
        </CardContent>
      </Card>
    </div>
  )
}
